import { Loader2Icon } from 'lucide-react'
import { FC } from 'react'
import { cn } from '@wellesley/ui'

type LoaderProps = {
  className?: string
}

export const Loader: FC<LoaderProps> = ({ className }) => (
  <Loader2Icon className={cn('animate-spin', className)} />
)
